import pxToRem from '../utils/pxToRem';

const tScale1 = {
  1: { fontSize: pxToRem(33), leading: pxToRem(40), paragraph: pxToRem(20) },
  2: { fontSize: pxToRem(28), leading: pxToRem(36), paragraph: pxToRem(18) },
  3: { fontSize: pxToRem(23), leading: pxToRem(30), paragraph: pxToRem(15) },
  4: { fontSize: pxToRem(19), leading: pxToRem(27), paragraph: pxToRem(14) },
  5: { fontSize: pxToRem(16), leading: pxToRem(24), paragraph: pxToRem(12) },
  6: { fontSize: pxToRem(14), leading: pxToRem(20), paragraph: pxToRem(10) },
  7: { fontSize: pxToRem(12), leading: pxToRem(16), paragraph: pxToRem(8) },
};

const tScale2 = {
  1: { fontSize: pxToRem(44), leading: pxToRem(50), paragraph: pxToRem(25) },
  2: { fontSize: pxToRem(35), leading: pxToRem(42), paragraph: pxToRem(21) },
  3: { fontSize: pxToRem(28), leading: pxToRem(36), paragraph: pxToRem(18) },
  4: { fontSize: pxToRem(22), leading: pxToRem(31), paragraph: pxToRem(16) },
  5: { fontSize: pxToRem(16), leading: pxToRem(24), paragraph: pxToRem(12) },
  6: { fontSize: pxToRem(14), leading: pxToRem(20), paragraph: pxToRem(10) },
  7: { fontSize: pxToRem(12), leading: pxToRem(16), paragraph: pxToRem(8) },
};

// ExtraLarge is for promo sites really, so lets leave it off for now
const tScale3 = {
  1: { fontSize: pxToRem(57), leading: pxToRem(66), paragraph: pxToRem(33) },
  2: { fontSize: pxToRem(43), leading: pxToRem(52), paragraph: pxToRem(26) },
  3: { fontSize: pxToRem(32), leading: pxToRem(42), paragraph: pxToRem(21) },
  4: { fontSize: pxToRem(24), leading: pxToRem(31), paragraph: pxToRem(16) },
  5: { fontSize: pxToRem(16), leading: pxToRem(24), paragraph: pxToRem(12) },
  6: { fontSize: pxToRem(14), leading: pxToRem(20), paragraph: pxToRem(10) },
  7: { fontSize: pxToRem(12), leading: pxToRem(16), paragraph: pxToRem(8) },
};

const tScaleValues = {
  tScale1,
  tScale2,
  tScale3,
};

const getFontSize = (rs) => (value) => {
  return tScaleValues[`tScale${rs}`][value].fontSize;
};
const getLeading = (rs) => (value) => {
  return tScaleValues[`tScale${rs}`][value].leading; // line-height
};
const getParagraphSpace = (rs) => (value) => {
  return tScaleValues[`tScale${rs}`][value].paragraph;
};

const getRScaleValue = (rs) => {
  const rScale = {};

  for (let i = 0; i <= 12; i++) {
    let delta = 0;
    if (rs === 2) {
      delta = i > 9 ? 8 : 4;
    } else if (rs === 3) {
      // Extra Large is for promo sites really, so lets leave it off for now.
      delta = i > 9 ? 16 : 8;
    }
    rScale[i] = pxToRem(i * 4 + delta);
  }

  return (value) => {
    return rScale[value];
  };
};

const getFScaleValue = (value) => {
  return pxToRem(value);
};

const SMALL_SCALE = 1;
const LARGE_SCALE = 2;

const buildScales = (props, isMediumOrLower) => {
  const { fontSize, leading, space, rUnit, fUnit } = props;
  const rs = isMediumOrLower ? SMALL_SCALE : LARGE_SCALE;

  return {
    fontSize: fontSize ? fontSize : getFontSize(rs),
    leading: leading ? leading : getLeading(rs),
    space: space ? space : getParagraphSpace(rs),
    rUnit: rUnit ? rUnit : getRScaleValue(rs),
    fUnit: fUnit ? fUnit : getFScaleValue,
  };
};

export default buildScales;
